import React , { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import { DiceFlatComponent } from '../../../dice/components/DiceComponent'


export class DeleteScoreKey extends React.Component {
  triggerScore = () => {
    const { value } = this.props
    if(this.props.onChange) this.props.onChange( value )
  }
  render () {
    const size = this.props.size || 8
    const cls = 'col-md-' + size + ' col-sm-' + size + ' col-xs-' + size
    return (
        <div className={cls + ' text-center padkey danger-key'} onClick={this.triggerScore}>
          <i className="fa fa-times" />
        </div>
    )
  }
}


export class BlankKey extends Component {
  render () {
    return (
        <div className="col-md-4 col-sm-4 col-xs-4 text-center padkey danger-key">
          &nbsp;
        </div>
    )
  }
}


export class DiceKey extends React.Component {
  triggerScore = () => {
    if(this.props.onChange) this.props.onChange(this.props.value)
  }
  render () {
    const { value } = this.props
    return (
        <div className="col-md-2 col-sm-2 col-xs-2 text-center" onClick={this.triggerScore}>
          <DiceFlatComponent className="animated bounceIn" faceUp={value} />
        </div>
    )
  }
}

export class PlaceholderKey extends React.Component {
  render () {
    return (
        <div className="col-md-2 col-sm-2 col-xs-2 text-center">
          <div className="dice-placehoder"/>
        </div>
    )
  }
}

export class DicePad extends React.Component {
  triggerScore = (v,i) => {
    if(this.props.onChange)  this.props.onChange(v,i)
  }
  picked = () => {
    const { picked } = this.props
    const keys = picked.map((v,i)=><DiceKey onChange={v =>this.triggerScore(v,i)} key={'e'+i}  value={v}  />)
    keys.unshift(<div className="col-md-1 col-sm-1 col-xs-1 text-center" />)
    if (picked.length < 5) {
      for (let i = 1; i < 6 - picked.length ; i++) {
        keys.push(<PlaceholderKey key={'b'+i} />)
      }
    }
    return keys
  }
  dices = () => {
    const keys = []
    for (let i = 1; i < 7 ; i++) {
      keys.push(<DiceKey onChange={this.triggerScore} key={'e'+i}  value={i}  />)
    }
    return keys
  }
  render () {
    const { picked, style } = this.props
    const children = picked ? this.picked() : this.dices()
    return (<div className="row" style={style} children={children} />)
  }
}


class ButtonZero extends Component {
  triggerScore = () => {
    if(this.props.onChange) this.props.onChange(0)
  }
  render () {
    const { label, secondary} = this.props
    return (<RaisedButton secondary={secondary} label={label} onClick={this.triggerScore} />)
  }
}

class ButtonCancel extends Component {
  triggerScore = () => {
    if(this.props.onChange) this.props.onChange( 'x' )
  }
  render () {
    const { label, secondary} = this.props //value
    return (<RaisedButton secondary={secondary} label={label} onClick={this.triggerScore} />)
  }
}


export class DiceScorePad extends Component {
  triggerScore = (v) => {
    if(this.props.onChange)  this.props.onChange(v)
  }
  render () {

    return (
        <div style={{padding:'20px 20px 20px 20px'}}>
          <div className="row" style={{marginBottom:'40px'}}>
            {this.props.children}
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-6">
              <div className="row">
                <ButtonZero label="Rayer" onChange={this.triggerScore} />
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-6">
              <div className="row">
                <ButtonCancel label="Annuler" secondary={true} onChange={this.triggerScore}  />
              </div>
            </div>
          </div>
        </div>
    )
  }
}

export default DiceScorePad


// WEBPACK FOOTER //
// ./src/game/level/components/types/SharedLevelComponent.jsx